/**
 * Level Up — side-by-side Sheet A / Sheet B allocation. THE ONLY page where
 * the dual-sheet split is fully exposed to the player. ASI/Feat toggle per
 * sheet, live merged preview, plain-English change summary, confirm/reset.
 *
 * Stub: scaffold for the most data-model-heavy page.
 */
export default function LevelUp() {
  return (
    <div>
      <h1>Level Up</h1>
      <div style={{ display: 'flex', gap: 24 }}>
        <section style={{ flex: 1 }}>
          <h2 className="sheet-a">Sheet A</h2>
          <p>Relearning ledger · class features · ASI / Feat</p>
        </section>
        <section style={{ flex: 1 }}>
          <h2 className="sheet-b">Sheet B</h2>
          <p>Original timeline ledger · class features · ASI / Feat</p>
        </section>
      </div>
      <p>This page is a scaffold. Build the allocation panels next.</p>
    </div>
  );
}
